import { headerSearch } from "../../plugins/ComponentsUi/HeaderSearch/HeaderSearch";
import { detectCloseElement } from "./helper";
/*==================== Header ====================*/
/**
 * @param header
 */
const vw = $(window).width();
export const header = {
	scrollActive: function () {
		let height = $("header").height();
		if ($(window).scrollTop() > height) {
			$("header").addClass("active");
		} else {
			$("header").removeClass("active");
		}
	},
	megamenu: function () {
		if (!window.matchMedia("(min-width: 1199.98px)").matches) return;
		// Toggle mega menu on click
		$(document).on("click", ".dropdown-product>a", function (e) {
			e.preventDefault();
			$(".menu-mega-main").toggleClass("active");
		});

		// Handle main tab hover
		$(document).on("mouseenter", ".menu-list a", function () {
			const targetId = $(this).attr("href");
			$(this).parent().addClass("current").siblings().removeClass("current");
			$(this).closest(".dropdown-product-list").find(targetId).siblings(".tab-content-menu").hide();
			$(this).closest(".dropdown-product-list").find(targetId).show();
		});

		// Handle sub-item hover
		$(document).on("mouseenter", ".menu-sub-list a", function () {
			const targetId = $(this).data("tab");
			$(this).parent().addClass("current").siblings().removeClass("current");
			$(this).closest(".tab-content-menu").find(targetId).siblings(".tab-content-sub").hide();
			$(this).closest(".tab-content-menu").find(targetId).show();
		});

		$(document).on("mouseenter", ".menu-sub-child-list a.tab-item-news", function () {
			const $newsContent = $(this).closest(".tab-content-sub").find(".item-news-content");
			const title = $(this).data("title");
			const content = $(this).data("content");
			const imgSrc = $(this).data("img");
			const link = $(this).attr("href");

			$(this).parent().addClass("current").siblings().removeClass("current");

			// Update news content
			$newsContent.find(".title a").text(title);
			$newsContent.find(".desc").text(content);
			$newsContent.find(".img img").attr("src", imgSrc);
			$newsContent.find("a").attr("href", link);
		});

		// Close mega menu when clicking outside
		$(document).on("click", function (e) {
			if (
				!$(e.target).closest(".menu-mega-main").length &&
				!$(e.target).closest(".dropdown-product").length
			) {
				$(".menu-mega-main").removeClass("active");
			}
		});

		// Close button functionality
		$(document).on("click", ".menu-mega-main .close", function () {
			$(".menu-mega-main").removeClass("active");
		});
	},
	mobile: function () {
		$(".header-bar").on("click", function () {
			$(this).toggleClass("active");
			// $("body").toggleClass("isOpenMenu overlay-active");
			// Đổi icon
			// const $icon = $(this).find("i");
			// $icon.toggleClass("fa-bars fa-xmark");
		});
		$('.header-bar-close').on('click', function () {
			$("body").removeClass("isOpenMenu overlay-active");
			$('.header-bar').removeClass('active')
		});

		if (window.innerWidth < 1198) {
			// Ẩn các menu con ban đầu
			$(
				".header-menu .sub-menu, .header-menu .sub-menu-children, .header-menu .sub-menu-children-dropdown"
			).hide();

			// Chỉ bắt sự kiện click trên icon mũi tên thôi
			$(".header-menu").on("click", ".dropdown-toggle-arrow", function (e) {
				e.preventDefault();
				e.stopPropagation();

				const $a = $(this).closest("a");

				$a.toggleClass("dropdown-active")
					.next()
					.stop(true, true)
					.slideToggle()
					.parent()
					.siblings()
					.find("a")
					.removeClass("dropdown-active")
					.next()
					.slideUp();
			});
		}

		// footer link

		if (window.innerWidth < 768) {
			$(".footer .footer-link .footer-menu").hide();

			$(".footer .footer-link h3").on("click", function (e) {
				e.preventDefault();

				$(this)
					.toggleClass("dropdown-active")
					.next()
					.slideToggle()
					.parent()
					.siblings()
					.find("h3")
					.removeClass("dropdown-active")
					.next()
					.slideUp();
			});
		}
	},
	initVariable: function () {
		const $header = document.querySelector("header");
		if (!$header) return;

		// Hàm cập nhật chiều cao header
		function updateHeaderHeight () {
			const height = $header.offsetHeight;
			document.documentElement.style.setProperty("--header-height", `${height}px`);
		}

		// Cập nhật ban đầu
		updateHeaderHeight();

		// Theo dõi mọi thay đổi chiều cao của header
		const ro = new ResizeObserver(updateHeaderHeight);
		ro.observe($header);

		// Phòng trường hợp ảnh hoặc font chưa load xong
		window.addEventListener("load", () => {
			setTimeout(updateHeaderHeight, 100);
		});
	},
	openMiniCart: () => {
		$("header .header-cart").addClass("active");
		$(".mini-cart-wrapper").addClass("active");
	},
	closeMiniCart: () => {
		$("header .header-cart").removeClass("active");
		$(".mini-cart-wrapper").removeClass("active");
	},
	handleOpenMiniCart: () => {
		// let isAllowOpen = true;
		// const preventOpenOn = [".woocommerce-checkout", ".woocommerce-cart"];
		// preventOpenOn.forEach((item) => {
		// 	if ($(item).length) {
		// 		isAllowOpen = false;
		// 	}
		// });
		// if (!isAllowOpen) return;
		$("body").on("click", "header .header-cart", function () {
			header.openMiniCart();
		});
		$(document).on("click", function (event) {
			var $trigger = $("header .header-cart");
			var $trigger_2 = $(".mini-cart-wrapper");
			if (
				$trigger !== event.target &&
				!$trigger.has(event.target).length &&
				$trigger_2 !== event.target &&
				!$trigger_2.has(event.target).length &&
				$(".mini-cart-wrapper").hasClass("active")
			) {
				console.log("close");
				header.closeMiniCart();
			}
		});
		$(".close-mini-cart").on("click", function () {
			header.closeMiniCart();
		});
	},
	handleMegaMenu: () => {
		// if (!window.matchMedia("(min-width: 1199.98px)").matches) return;
		// $(document)
		// 	.on("mouseenter", ".mega-product", function () {
		// 		$("body").addClass("header-mega-active");
		// 	})
		// 	.on("mouseleave", ".mega-product", function () {
		// 		$("body").removeClass("header-mega-active");
		// 	});
	},
	closeMenuMobile: () => {
		$('body').removeClass('isOpenMenuMobile')
		$('body').removeClass('isOpenMenu')
		$('.header-bar').removeClass('active')
	},
	headerWrapMenuMobile: () => {
		if (!window.matchMedia("(min-width: 1200px)").matches) {
			$('.header-wrap-menu>.header-nav>li.menu-item-has-children>a, .header-wrap-menu .mega-product-list .name-product.menu-item-has-children>a').wrap('<div class="header-menu-item"></div>').parent().append('<div class="dropdown-icon"><i class="fa-light fa-chevron-down"></i></div>')
		}
		$('.header-wrap-menu>.header-nav>li.menu-item-has-children .dropdown-icon, .header-wrap-menu .mega-product-list .name-product .dropdown-icon').on('click', function () {
			$(this).parent().toggleClass('active')
			$(this).parent().next().slideToggle()
		})
		$('.header-bar').on('click', function () {
			$('body').toggleClass('isOpenMenuMobile')
		})
		$('.header-menu-mobile .header-close').on('click', function () {
			$('body').removeClass('isOpenMenuMobile')
			$('body').removeClass('isOpenMenu')
			$('.header-bar').removeClass('active')
		})
		$('.overlay-menu').on('click', function () {
			$('body').removeClass('isOpenMenuMobile')
			$('body').removeClass('isOpenMenu')
			$('.header-bar').removeClass('active')
		})
	},
	headerMenuClickHash: () => {
		if (window.matchMedia("(min-width: 1200px)").matches) return;
		$('.header-menu-mobile .header-nav li:first-child .sub-menu li a').on('click', function (e) {
			console.log('click');
			header.closeMenuMobile();
		})
	},
	init: function () {
		headerSearch();
		header.scrollActive();
		header.handleOpenMiniCart();
		header.mobile();
		header.initVariable();
		header.handleMegaMenu();
		header.headerWrapMenuMobile();
		header.headerMenuClickHash();
	},
};
document.addEventListener(
	"scroll",
	function (e) {
		header.scrollActive();
	},
	true
);
